import { action } from 'mobx'
import { validationContext } from 'validx'
import { validateObject } from '@/utils/validx-util'
import { ContactInfoEditorViewModel } from '@/features/jobs/info-gathering/ContactInfoEditorViewModel'
import { BusinessInfoEditorViewModel } from './BusinessInfoEditorViewModel'
import type { BusinessProfileVersion } from './BusinessProfileVersion'

/**
 * Editor for a business profile.
 */
export class BusinessProfileEditorViewModel {
  readonly businessInfoVm = new BusinessInfoEditorViewModel()
  readonly contactInfoVm = new ContactInfoEditorViewModel()

  readonly validation = validationContext(this, {
    businessInfoVm: [validateObject()],
    contactInfoVm: [validateObject()],
  })

  /**
   * Resets the editor to the given profile, or to defaults.
   */
  @action.bound
  reset(profile?: BusinessProfileVersion | null) {
    this.businessInfoVm.reset(profile?.businessInfo)
    this.contactInfoVm.reset(profile?.contactInfo)
    this.validation.reset()
  }
}
